import PreviewIcon from "@mui/icons-material/DesktopWindowsOutlined";
import { Box, Button, Typography } from "@mui/material";

interface Props {
  title: string;
  previewDisabled: boolean;
  onPreviewClick: () => void;
}

const InvestorCommunicationContentFormHeader = ({ title, previewDisabled, onPreviewClick }: Props) => (
  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
    <Typography variant="subtitle1">{title}</Typography>
    <Button
      variant="outlined"
      color="secondary"
      startIcon={<PreviewIcon />}
      onClick={onPreviewClick}
      disabled={previewDisabled}
    >
      Preview
    </Button>
  </Box>
);

export default InvestorCommunicationContentFormHeader;
